import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateCremationStructureReport } from '../../../services/report/ReportService';

class CremationStructureReport extends SpecificationReportPage {

  getFields() {
    return ['year'];
  }

  getService() {
    return generateCremationStructureReport;
  }

  getFileName() {
    return "1C-struktura-kremacija";
  }

  getPageTitle() {
    return strings.specificationReports.cremationStructureTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(CremationStructureReport)));
